module.exports = __webpack_public_path__ + "img/picto_info.2ed791a8.png";